import { pluginApi } from 'services/api';

export interface Filters {
  canal?: string;
  regional?: string;
  uf?: string;
  municipio?: string;
  produtorComNfs?: string;
  farmersWithInvoicesCurrentSeason?: string;
}

export default async (getValuesProducerId: number, getValuesProducerCampaign: number | undefined, filters: Filters | undefined ) => {
  
  const { data } = await pluginApi.get(
    `/participants/produtor/getValuesSelectedProducerB?campaign=${getValuesProducerCampaign}&idProducer=${getValuesProducerId}`,{
      params: filters,
    }
  );
  return data;
};